
import React from "react";
import { TabsContent } from "@/components/ui/tabs";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PlayCircle, Building } from "lucide-react";

const OngoingExamsTab = ({ ongoingExams, selectedCompany, companies, onStartExam }) => {

  const selectedCompanyObj = companies?.find((c) => c.id === selectedCompany);
  const selectedCompanyName = selectedCompanyObj?.name || "Unknown Company";

  const getExamStatusBadge = (status) => {
    const statusConfig = {
      pending: { color: "bg-yellow-100 text-yellow-800", text: "Pending" },
      ongoing: { color: "bg-blue-100 text-blue-800", text: "In Progress" },
      completed: { color: "bg-green-100 text-green-800", text: "Completed" },
      disqualified: { color: "bg-red-100 text-red-800", text: "Disqualified" },
    };

    const config = statusConfig[status] || statusConfig.pending;
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}>
        {config.text}
      </span>
    );
  };

  if (selectedCompany === "all" || !selectedCompany) {
    return (
      <TabsContent value="ongoing" className="space-y-4">
        <Card>
          <CardContent className="flex flex-col items-center justify-center py-12">
            <PlayCircle className="h-12 w-12 text-gray-400 mb-4" />
            <h3 className="text-lg font-semibold mb-2">Select a Company</h3>
            <p className="text-gray-600 text-center">
              Please select a company from the dropdown to view ongoing exams.
            </p>
          </CardContent>
        </Card>
      </TabsContent>
    );
  }

  if (ongoingExams.length === 0) {
    return (
      <TabsContent value="ongoing" className="space-y-4">
        <Card>
          <CardContent className="flex flex-col items-center justify-center py-12">
            <PlayCircle className="h-12 w-12 text-gray-400 mb-4" />
            <h3 className="text-lg font-semibold mb-2">No Ongoing Exams</h3>
            <p className="text-gray-600 text-center">
              No ongoing exams for the selected company.
            </p>
          </CardContent>
        </Card>
      </TabsContent>
    );
  }

  return (
    <TabsContent value="ongoing" className="space-y-4">
      <div className="grid gap-4">
        {ongoingExams.map((assignment) => (
          <Card key={assignment._id} className="border-blue-200 bg-blue-50">
            <CardHeader>
              <div className="flex items-center justify-between">
                <div>
                  <CardTitle className="text-lg">{assignment.examId.name}</CardTitle>
                  <CardDescription>{assignment.examId.description}</CardDescription>
                  <div className="flex items-center gap-2 mt-2">
                    <Building className="h-4 w-4 text-gray-500" />
                    <span className="text-sm text-gray-600">
                      {selectedCompanyName}
                    </span>
                  </div>
                </div>
                {getExamStatusBadge(assignment.status)}
              </div>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-blue-700 mb-4">
                You have an exam in progress. Click below to resume.
              </p>
              <Button onClick={() => onStartExam(assignment._id)} variant="default">
                Resume Exam
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </TabsContent>
  );
};

export default OngoingExamsTab;